import {HttpHelper} from "../helpers/HttpHelper";
import plantillas from "./DescripcionesCeramicaServicioPlantillas.json"
import mapas from "./DescripcionesCeramicaServicioMapas.json"

window.DescripcionesCeramica = {
    codigo_dermis: {},
    valoresDefecto: {},
    texto: {},
    proyecto: {},
    solucion_constructiva: {},

    generaTextoJuntas() {
        if (['GP', 'GE'].includes(this.codigo_dermis)) {
            if (this.proyecto.tipoSolCons.codigo == "obra_nueva_horizontal") {
                if (['baja', 'media'].includes(this.proyecto.escenario.intensidadTransito.codigo)) return 'con junta de colocación mínima (1,5-3 mm), según UNE 138002.'
                else return 'con junta de colocación abierta (> 3 mm), según UNE 138002.'
            } else if (this.proyecto.tipoSolCons.codigo == "obra_nueva_exterior" || this.proyecto.tipoSolCons.codigo == "rehabilitacion_exterior") {
                return "con junta de colocación muy abierta (> 5 mm), según UNE 138002.";
            } else {
                if (['low', 'medium'].includes(this.proyecto.escenario.trafficIntensity.code)) return 'con junta de colocación mínima (1,5-3 mm), según UNE 138002.'
                return 'con junta de colocación abierta (> 3 mm), según UNE 138002.'
            }
        } else if (['LC', 'GR', 'L'].includes(this.codigo_dermis)) {
            if (this.proyecto.tipoSolCons.codigo == "obra_nueva_exterior"
                || this.proyecto.tipoSolCons.codigo == "rehabilitacion_exterior")
                return "con junta de colocación muy abierta (> 5 mm), según UNE 138002.";
            return 'con junta de colocación abierta (> 3 mm), según UNE 138002.'
        } else if (['AAC+G', '[L2]', '[G2]', '[G3]'].includes(this.codigo_dermis)) {
            return 'con junta de colocación muy abierta (> 5 mm), según UNE 138002.'
        } else if (['A', 'G'].includes(this.codigo_dermis)) {
            return 'con junta de colocación mínima (1,5-3 mm), según UNE 138002.'
        }
    },

    compruebaValor(valorRegistro, valorComparacion) {
        if (!valorRegistro) return true;
        let valores = [];
        if (valorRegistro.includes(",")) valores = valorRegistro.split(',');
        else valores.push(valorRegistro);

        if (valorRegistro.includes(valorComparacion)) return true;
        return false;
    },

    compruebaValorConReferencia(valorRegistro, valorComparacion) {
        if (!valorRegistro) return true;
        let valores = [];
        if (valorRegistro.includes(",")) valores = valorRegistro.split(',');
        else valores.push(valorRegistro);
        var resultado = false;
        valores.forEach((valor) => {
            if (valorComparacion.includes(valor)) resultado = true;
        });
        return resultado;
    },

    calculaLadoMasLargo() {
        let formatoPieza = this.valoresDefecto.formato;
        if (this.solucion_constructiva.materialPersonalizado != null) formatoPieza = this.solucion_constructiva.materialPersonalizado.formato;
        var ladoMasLargo = Math.max(parseInt(formatoPieza.split('x')));
        if (ladoMasLargo <= 30) return '0_30'
        if (ladoMasLargo > 30 && ladoMasLargo <= 60) return '30_60';
        if (ladoMasLargo > 60 && ladoMasLargo <= 90) return '60_90';
        else return '90'
    },

    calculaAbsorcionAgua() {
        let capacidad_absorcion = this.valoresDefecto.capacidad_absorcion;
        if (this.solucion_constructiva.materialPersonalizado != null) capacidad_absorcion = this.solucion_constructiva.materialPersonalizado.absorcionAgua.codigo;
        return capacidad_absorcion;
    },

    generaTextoAdhesivoLaminas() {
        let adhesivo = 'C2 S2';
        if (this.codigo_dermis == '[L2]') adhesivo = 'C2 S1 TE';
        else {
            let formato = this.valoresDefecto.formato;
            if (this.solucion_constructiva.materialPersonalizado != null) formato = this.solucion_constructiva.materialPersonalizado.formato;
            var ladoMasLargo = Math.max(formato.split('x'))
            if (ladoMasLargo <= 70) adhesivo = 'C2 S1';
            if (ladoMasLargo > 70) adhesivo = 'C2 S2';
        }
        return mapas['adhesivo_textos'][adhesivo];
    },

    generaTextoAdhesivoHorizontal() {
        let solucion_constructiva = this.solucion_constructiva, proyecto = this.proyecto;
        let resultado = null;
        if (solucion_constructiva.tipoSolucion.codigo == 'obra_nueva_horizontal') {
            resultado = mapas['adhesivo_obra_nueva_horizontal'].find((registro) => {
                return this.compruebaValor(registro.intensidadTransito, proyecto.escenario.intensidadTransito.codigo) &&
                    this.compruebaValor(registro.materialCapaIntermedia, solucion_constructiva.materialCapaIntermedia.referencia) &&
                    this.compruebaValor(registro.materialDermis, this.codigo_dermis) &&
                    this.compruebaValor(registro.abosrcionAgua, this.calculaAbsorcionAgua()) &&
                    this.compruebaValor(registro.ladoMasLargo, this.calculaLadoMasLargo());
            });
        } else if (solucion_constructiva.tipoSolucion.codigo == 'obra_nueva_exterior') {
            resultado = mapas['adhesivo_obra_nueva_exterior'].find((registro) => {
                return this.compruebaValor(registro.intensidadTransito, proyecto.escenario.frecMantExterior.codigo) &&
                    this.compruebaValor(registro.materialCapaIntermedia, "R") &&
                    this.compruebaValor(registro.materialDermis, this.codigo_dermis) &&
                    this.compruebaValor(registro.abosrcionAgua, this.calculaAbsorcionAgua()) &&
                    this.compruebaValor(registro.ladoMasLargo, this.calculaLadoMasLargo());
            });
        } else if (solucion_constructiva.tipoSolucion.codigo == 'rehabilitacion_exterior') {
            resultado = mapas['adhesivo_rehabilitacion_exterior'].find((registro) => {
                return this.compruebaValor(registro.intensidadTransito, proyecto.escenario.frecMantExterior.codigo) &&
                    this.compruebaValor(registro.revestimientoExistente, solucion_constructiva.dermisExistente.referencia) &&
                    this.compruebaValor(registro.materialCapaIntermedia, solucion_constructiva.regularizacion.codigo === "no" ? "null" : "R") &&
                    this.compruebaValor(registro.materialDermis, this.codigo_dermis) &&
                    this.compruebaValor(registro.abosrcionAgua, this.calculaAbsorcionAgua()) &&
                    this.compruebaValor(registro.ladoMasLargo, this.calculaLadoMasLargo());
            });
        } else {
            resultado = mapas['adhesivo_rehabilitacion_horizontal'].find((registro) => {
                return this.compruebaValor(registro.trafficIntensity, proyecto.escenario.trafficIntensity.code) &&
                    this.compruebaValorConReferencia(registro.materialCapaIntermedia, solucion_constructiva.referencia) &&
                    this.compruebaValor(registro.existingCoating, proyecto.escenario.existingCoating.reference) &&
                    this.compruebaValor(registro.materialDermis, this.codigo_dermis) &&
                    this.compruebaValor(registro.abosrcionAgua, this.calculaAbsorcionAgua()) &&
                    this.compruebaValor(registro.ladoMasLargo, this.calculaLadoMasLargo());
            });
        }
        return mapas['adhesivo_textos'][resultado.adhesivo];
    },

    generaTextoAdhesivoVertical() {
        let solucion_constructiva = this.solucion_constructiva;
        let resultado = null;
        if (solucion_constructiva.tipoSolucion.codigo == 'obra_nueva_vertical') {
            resultado = mapas['adhesivo_obra_nueva_vertical'].find((registro) => {
                return this.compruebaValorConReferencia(registro.materialSoporte, solucion_constructiva.referencia) &&
                    this.compruebaValor(registro.materialDermis, this.codigo_dermis) &&
                    this.compruebaValor(registro.abosrcionAgua, this.calculaAbsorcionAgua()) &&
                    this.compruebaValor(registro.ladoMasLargo, this.calculaLadoMasLargo());
            });
        } else {
            resultado = mapas['adhesivo_rehabilitacion_vertical'].find((registro) => {
                return this.compruebaValorConReferencia(registro.materialCapaIntermedia, solucion_constructiva.referencia) &&
                    this.compruebaValor(registro.materialDermis, this.codigo_dermis) &&
                    this.compruebaValor(registro.abosrcionAgua, this.calculaAbsorcionAgua()) &&
                    this.compruebaValor(registro.ladoMasLargo, this.calculaLadoMasLargo());
            });
        }
        return mapas['adhesivo_textos'][resultado.adhesivo];
    },

    generaTextoAdhesivoUrbano() {
        switch (this.calculaLadoMasLargo()) {
            case '0_30':
                return mapas['adhesivo_textos']['C2'];
            case '30_60':
                return mapas['adhesivo_textos']['C2 S1'];
            case '60_90':
            case '90':
                return mapas['adhesivo_textos']['C2 S2'];
            default:
                return mapas['adhesivo_textos']['C2'];
        }
    },

    generaTextoAdhesivoFachada() {
        switch (this.calculaLadoMasLargo()) {
            case '0_30':
            case '30_60':
                return mapas['adhesivo_textos']['C2 S1 TE'];
            case '60_90':
            case '90':
                return mapas['adhesivo_textos']['C2 S2 TE'];
        }
    },

    generaTextoRejuntadoHorizontal() {
        let intensidadTransito
        let frecuenciaMantenimiento;
        let tipoLocal;
        let necesidadesHigiene;

        switch (this.proyecto.tipoSolCons.codigo) {
            case "horizontal_rehabilitation":
                intensidadTransito = this.proyecto.escenario.trafficIntensity.code;
                frecuenciaMantenimiento = this.proyecto.escenario.maintenanceFrequency.code;
                tipoLocal = this.proyecto.escenario.localType.code;
                necesidadesHigiene = this.proyecto.escenario.needsHygiene.code;
                break;
            case "obra_nueva_exterior":
            case "rehabilitacion_exterior":
                return mapas['rejuntado_textos']["CG2WA"];
            default:
                intensidadTransito = this.proyecto.escenario.intensidadTransito.codigo;
                frecuenciaMantenimiento = this.proyecto.escenario.frecuenciaMantenimiento.codigo;
                tipoLocal = this.proyecto.escenario.tipoLocal.codigo;
                necesidadesHigiene = this.proyecto.escenario.necesidadHigiene.codigo;
        }

        let resultado = mapas['rejuntado_horizontal'].find((registro) => {
            return this.compruebaValor(registro.intensidadTransito, intensidadTransito) &&
                this.compruebaValor(registro.frecuenciaMantenimiento, frecuenciaMantenimiento) &&
                this.compruebaValor(registro.tipoLocal, tipoLocal) &&
                this.compruebaValor(registro.necesidadesHigiene, necesidadesHigiene);
        });

        return mapas['rejuntado_textos'][resultado.rejuntado];
    },
    generaTextoRejuntadoVertical() {
        let uso = (this.proyecto.tipoSolCons.codigo == 'vertical_rehabilitation') ? this.proyecto.escenario.use.code : this.proyecto.escenario.uso.codigo;
        let necesidades_higiene = (this.proyecto.tipoSolCons.codigo == 'vertical_rehabilitation') ? this.proyecto.escenario.needsHygiene.code : this.proyecto.escenario.necesidadHigiene.codigo;
        if (uso == 'publico_hospitalario_comecial' && ['si', 'yes'].includes(necesidades_higiene)) return mapas['rejuntado_textos']['RG'];
        return mapas['rejuntado_textos']['CG2W'];
    },

    generaTextoAdhesivo() {
        switch (this.codigo_dermis) {
            case 'LC':
            case 'L':
            case '[L2]':
                return this.generaTextoAdhesivoLaminas();
            case 'GP':
            case 'GE':
            case 'GR':
                return this.generaTextoAdhesivoHorizontal();
            case 'G':
            case 'A':
                return this.generaTextoAdhesivoVertical();
            case 'AAC+G':
                return this.generaTextoAdhesivoUrbano();
            case '[G2]':
            case '[G3]':
                return this.generaTextoAdhesivoFachada();
        }
    },

    generaTextoRejuntado() {
        switch (this.codigo_dermis) {
            case 'LC':
            case 'GP':
            case 'GE':
            case 'GR':
                return this.generaTextoRejuntadoHorizontal();
            case 'L':
            case 'G':
            case 'A':
                return this.generaTextoRejuntadoVertical();
            case 'AAC+G':
                return mapas['rejuntado_textos']['CG2WA'];
            case '[L2]':
            case '[G2]':
            case '[G3]':
                return mapas['rejuntado_textos']['CG2WA'];
        }
    },

    aplicaTextosAbsorcion(plantilla) {
        let capacidad_absorcion = this.valoresDefecto.capacidad_absorcion;
        if (this.solucion_constructiva.materialPersonalizado != null) capacidad_absorcion = this.solucion_constructiva.materialPersonalizado.absorcionAgua.codigo;
        plantilla = plantilla.replace('{capacidad_absorcion}', mapas['capacidad_absorcion_textos'][capacidad_absorcion]);

        let grupo_absorcion = this.valoresDefecto.grupo_absorcion;
        if (this.codigo_dermis == 'GE') {
            if (['AB_0_5', 'AB_3'].includes(capacidad_absorcion)) grupo_absorcion = 'BIb'
            if (['AB_6', 'AB_10'].includes(capacidad_absorcion)) grupo_absorcion = 'BIa'
        }
        if (this.codigo_dermis == 'GR') {
            if (['AB_0_5', 'AB_3'].includes(capacidad_absorcion)) grupo_absorcion = 'AIb'
            if (['AB_6', 'AB_10'].includes(capacidad_absorcion)) grupo_absorcion = 'AIIa'
        }
        plantilla = plantilla.replace('{grupo_absorcion}', grupo_absorcion);
        return plantilla;
    },

    aplicaTextosFormatos(plantilla) {
        let formato = this.valoresDefecto.formato;
        if (this.solucion_constructiva.materialPersonalizado != null) formato = this.solucion_constructiva.materialPersonalizado.formato;
        let espesor = this.valoresDefecto.espesor;
        if (this.solucion_constructiva.materialPersonalizado != null) espesor = this.solucion_constructiva.materialPersonalizado.espesor;
        plantilla = plantilla.replace('{formato}', formato);
        plantilla = plantilla.replace('{espesor}', espesor);
        return plantilla;
    },

    aplicaTextosRecrecido(plantilla) {
        // eslint-disable-next-line
        if (['LC', 'GP', 'GE', 'GR'].includes(this.codigo_dermis)) {
            let intensidadTransito;
            switch (this.proyecto.tipoSolCons.codigo) {
                case "horizontal_rehabilitation":
                    intensidadTransito = this.proyecto.escenario.trafficIntensity.code;
                    break;
                case "obra_nueva_exterior":
                case "rehabilitacion_exterior":
                    intensidadTransito = this.proyecto.escenario.frecMantExterior.codigo;
                    break;
                default:
                    intensidadTransito = this.proyecto.escenario.intensidadTransito.codigo;
            }

            if (this.solucion_constructiva.referencia.includes('AC')) {
                if (['media', 'alta', 'medium', 'high'].includes(intensidadTransito)) {
                    plantilla = plantilla.replace("CT-C16-F3", "CT-C20-F3");
                    plantilla = plantilla.replace('50 mm de espesor', '60 mm de espesor');
                }
            } else if (this.solucion_constructiva.referencia.includes('BC')) {
                if (['media', 'alta', 'medium', 'high'].includes(intensidadTransito)) {
                    plantilla = plantilla.replace('CT-C16-F3', 'CT-C20-F3');
                }
                plantilla = plantilla.replace('50 mm de espesor', '40 mm de espesor');
            }
        }
        return plantilla;
    },

    aplicarPlantilla(codigo) {
        let valoresDefecto = plantillas.find((plantilla) => {
            if (typeof codigo !== "undefined") return plantilla.referencia == codigo;
            else return plantilla.referencia == this.codigo_dermis;
        });
        this.valoresDefecto = valoresDefecto;
        let plantilla = valoresDefecto.plantilla;
        plantilla = this.aplicaTextosFormatos(plantilla);
        plantilla = this.aplicaTextosAbsorcion(plantilla);
        plantilla = plantilla.replace('{rejuntado}', this.generaTextoRejuntado());
        plantilla = plantilla.replace('{juntas}', this.generaTextoJuntas());
        plantilla = plantilla.replace('{adhesivo}', this.generaTextoAdhesivo());
        return plantilla;
    },

    generar(id_proyecto, id_solucioncontuctiva, contenido_backend) {
        return HttpHelper.get(`proyecto/${id_proyecto}`)
            .then((res) => {
                this.proyecto = res
                this.solucion_constructiva = this.proyecto.solucionesConstructivas.find((solucioncontuctiva) => {
                    return solucioncontuctiva.id == id_solucioncontuctiva
                });
                this.codigo_dermis = this.solucion_constructiva.materialDermis.referencia;
                if (this.solucion_constructiva.materialDermis.codigo == 'horizontal_r_lamina') this.codigo_dermis = 'LC'
                if (this.solucion_constructiva.materialDermis.codigo == 'facade_r_baldosa_ceramica_g2') this.codigo_dermis = '[G2]'
                if (this.solucion_constructiva.materialDermis.codigo == 'facade_r_baldosa_ceramica_g3') this.codigo_dermis = '[G3]'

                let texto = contenido_backend
                if (['LC', 'GP', 'GE', 'GR', 'L', 'G', 'A', 'AAC+G', '[L2]', '[G2]', '[G3]'].includes(this.codigo_dermis)) {
                    if (['LC', 'GP', 'GE', 'GR'].includes(this.codigo_dermis) && (
                        res.tipoSolCons.codigo === "obra_nueva_exterior" || res.tipoSolCons.codigo === "rehabilitacion_exterior"
                    ))
                        texto = this.aplicarPlantilla(this.codigo_dermis + "_E");
                    else
                        texto = this.aplicarPlantilla();
                    texto += "<br>" + contenido_backend.substring(contenido_backend.indexOf('<ul>'));
                    texto = this.aplicaTextosRecrecido(texto);
                }
                texto = texto.replace("</ul>", "</ul><br>")
                return texto
            });
    }
}
